import { classNames } from "@components/library/utils/classNames";
import * as RadixDialog from "@radix-ui/react-dialog";

export interface DialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

interface ModalProps {
  image: string;
  alt: string;
  className?: string;

  open: boolean;
  onClose: () => void;
}

export const ImageModal = ({ image, alt, className, open, onClose }: ModalProps) => {
  return (
    <RadixDialog.Root open={open} onOpenChange={onClose}>
      <RadixDialog.Portal>
        <div className="fixed inset-0 z-[1001] animate-fade-in">
          <div className="flex items-center justify-center">
            <RadixDialog.Overlay className="fixed inset-0 grid items-center justify-center overflow-y-auto bg-black bg-opacity-50">
              <RadixDialog.Content
                className={classNames(
                  "relative m-24 flex max-w-[1260px] overflow-clip rounded-ms outline-none",
                  className,
                )}
              >
                <img alt={alt} src={image} onClick={onClose} />
              </RadixDialog.Content>
            </RadixDialog.Overlay>
          </div>
        </div>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
